import React, { PureComponent } from 'react';
import Waypoint from 'react-waypoint';

export default class ImageSlideIn extends PureComponent {

  constructor() {
    super();
    this.imagesRef = React.createRef();
  }

  componentDidMount() {
    const purposeImages = this.imagesRef.current.querySelectorAll('.js-slide-image');

    this.tl = new TimelineMax({ paused: true });

    this.tl
      .from(purposeImages, 0.25, { opacity: 0 }, 'sync')
      .staggerFrom(purposeImages, 1.5, { x: '10%', y: '100%', cycle: { rotation: [-22, 22] }, ease: Power4.easeOut }, 0.02, 'sync');
  }

  animateImages = () => {
    this.tl.play();
  }

  componentWillUnmount() {
    this.tl.kill();
  }

  render() {
    return (
      <div ref={this.imagesRef}>
        <Waypoint
          onEnter={this.animateImages}
          bottomOffset={250}
        />
        {this.props.children}
      </div>
    );
  }
}
